import { HelmetProvider } from "react-helmet-async";
import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { App } from "./App.tsx";

import "./assets/css/index.css";
import "./assets/css/font.css";

const root = document.getElementById("root")!;

createRoot(root).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);
